import { useQuery } from "react-query";
import { useRouter } from "../../useRouter";
import { useRecoilState } from "recoil";
import { userInfoAtom } from "src/atoms";
import { getOneNotice } from "src/service/notice";
import { useApiError } from "src/hooks/useApiError";

interface IUseJoinProps {
  onSuccess?: () => void;
  onError?: () => void;
}
export function useNoticeOne({ onSuccess, onError }: IUseJoinProps) {
  const [userInfo, setUserInfo] = useRecoilState(userInfoAtom);
  const { handleError } = useApiError();
  const { goConsole } = useRouter();
  const { data: notice } = useQuery("getOneNotice", getOneNotice, {
    refetchOnMount: true,
    onSuccess,
    onError: onError ?? handleError,
  });

  return { notice };
}
